import { render } from "./about.vue?vue&type=template&id=3fa5379c&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=3fa5379c&lang=scss&scoped=true"

import exportComponent from "D:\\乐得科技\\官网\\shark-web-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa5379c"]])

export default __exports__